"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var review_store_base_1 = __importStar(require("~/stores/forms/reviews/review_store_base"));
var validator_1 = __importDefault(require("~/validator/validator"));
var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1(defaultEmail, isHistoryBackable) {
        var _this = _super.call(this) || this;
        _this.email = defaultEmail || "";
        _this.haveDefaultEmail = Boolean(defaultEmail);
        _this.isHistoryBackable = isHistoryBackable;
        return _this;
    }
    Object.defineProperty(default_1.prototype, "submitReviewApiUrl", {
        get: function () {
            return "/api/hikakaku_reviews";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(default_1.prototype, "postReviewParams", {
        get: function () {
            return {
                hikakaku_review: {
                    reviewer_name: this.nickname,
                    reviewer_email: this.email,
                    content: this.content,
                    rating: this.rate,
                    user_input_map_name: this.userInputMapName,
                    update_nickname: this.updateNickname
                }
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(default_1.prototype, "getIsHistoryBackable", {
        get: function () {
            return this.isHistoryBackable;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(default_1.prototype, "validators", {
        get: function () {
            var _this = this;
            return [
                {
                    errorMessage: "ニックネームを入力してください",
                    validator: function () { return (validator_1.default.isEntered(_this.nickname) ? review_store_base_1.ValidateResult.VALID : review_store_base_1.ValidateResult.INVALID); }
                },
                {
                    errorMessage: "レビュー内容は10文字以上入力してください",
                    validator: function () { return (validator_1.default.isEntered(_this.content) && _this.content.length >= 10 ? review_store_base_1.ValidateResult.VALID : review_store_base_1.ValidateResult.INVALID); }
                },
                {
                    errorMessage: "星の数を入力してください",
                    validator: function () { return (validator_1.default.isEntered(_this.rate) && _this.rate > 0 ? review_store_base_1.ValidateResult.VALID : review_store_base_1.ValidateResult.INVALID); }
                },
            ];
        },
        enumerable: false,
        configurable: true
    });
    return default_1;
}(review_store_base_1.default));
exports.default = default_1;
